// The tab strip under a player's header (contracts/revenue.md §5): Profile and Subscription, so the
// subscription page reads as a nested route of the profile. The Subscription tab carries the player's
// subscription status (summary.status: the best production status, `free` with none).

import { NavLink } from "react-router";
import { usePlayerRevenue } from "../../api/revenue";
import { Chip } from "../../components/ui";
import { statusMeta } from "../../lib/revenue";
import r from "./revenue.module.css";

export function PlayerTabs({ id }: { id: string }) {
  const q = usePlayerRevenue(id);
  const status = q.data?.summary.status ?? null;
  const m = status ? statusMeta(status) : null;
  return (
    <nav className={r.tabs} aria-label="Player pages" data-testid="player-tabs">
      <NavLink to={`/players/${id}`} end className={r.tab}>
        Profile
      </NavLink>
      <NavLink to={`/players/${id}/subscription`} className={r.tab}>
        Subscription
        {m ? (
          <span data-testid="subscription-status" data-status={status}>
            <Chip tone={m.tone} title={m.hint || undefined}>
              {m.label}
            </Chip>
          </span>
        ) : null}
      </NavLink>
    </nav>
  );
}
